import ApplicationInput from "../../ui/ApplicationInput";
import Input from "../../ui/Input";
import {parseAndFormatDateForInput} from "../../util/DateUtil";
import Panel from "../../ui/Panel";
import React from "react";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";

const DailyListEditInputPanel = ({dailyList}) => {

    const {t} = useTranslation();
    const {register, control, formState: {errors}} = useFormContext();

    return (
        <Panel title={t('title.dailyList')}>
            <ApplicationInput
                name="application"
                defaultValue={dailyList?.application}
                control={control}
                rules={{required: t('validation.required')}}
                error={errors?.application}
            />

            <Input
                defaultValue={dailyList?.title}
                label={t('label.title')}
                error={errors?.title}
                {...register("title", {
                    required: t('validation.required')
                })}
            />

            <Input
                type="date"
                defaultValue={dailyList?.date ? parseAndFormatDateForInput(dailyList.date) : ""}
                label={t('label.date')}
                InputLabelProps={{shrink: true}}
                error={errors?.date}
                {...register("date", {
                    required: t('validation.required')
                })}
            />

        </Panel>
    )

}

export default DailyListEditInputPanel;
